/**
 * Main App.
 */
import * as React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {loadCSS} from 'fg-loadcss/src/loadCSS';
import './lib/reactifyCss';
import App from './layout/App';
import './config/i18nConfig';

import {configureStore} from './store';

class MainApp extends React.PureComponent {
    componentDidMount() {
        loadCSS(
            'https://use.fontawesome.com/releases/v5.1.0/css/all.css',
            document.querySelector('#insertion-point-jss'),
        );
    }

    render() {
        return (
            <Provider store={configureStore()}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <Router>
                        <Switch>
                            <Route path="/" component={App} />
                        </Switch>
                    </Router>
                </MuiPickersUtilsProvider>
            </Provider>
        );
    }
}

export default MainApp;
